import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useGraduateList = (params?: any) => {
  return useQuery({
    queryKey: ['graduate-list', params],
    queryFn: async () => {
      const res = await request.get('/graduate', { params });
      return res.data;
    }
  });
};
